import type {
    ImageExportCorner,
    ImageExportScreen,
} from "@/appInterface/windows/ExportWindow/ImageExport/ImageExportScreen";
import { canv } from "@/canv/global";
import { toolBase } from "../toolBase";

export class ImageExportTool extends toolBase {
    TryAction(type: string) {
        const screen = this.getScreen();
        if (!screen) return;

        const overCorner = screen.overCorner();
        const isOverRect = screen.isOverRect();
        const pt = canv.actionManager.getActionPoint();
        const prePt = canv.actionManager.getPreActionPoint();

        if (type === "mousedown") {
            if (overCorner) {
                this.mousedownOnCorner = overCorner;
            } else if (isOverRect) {
                this.isMousedownOnRect = true;
            }
        } else if (type === "mousemove") {
            if (this.mousedownOnCorner) {
                screen.resize(this.mousedownOnCorner);
            } else if (this.isMousedownOnRect) {
                screen.translate(pt.x - prePt.x, pt.y - prePt.y);
            }

            this.checkCursor();
        } else if (type === "mouseup") {
            this.mousedownOnCorner = null;
            this.isMousedownOnRect = false;
            this.checkCursor();
        }
    }

    checkCursor() {
        const screen = this.getScreen();
        if (!screen) return;

        const overCorner = screen.overCorner();
        const isOverRect = screen.isOverRect();

        if (overCorner) {
            if (this.cursor !== "nwse-resize" && ["leftTop", "rightBottom"].includes(overCorner)) {
                this.chooseCursor("nwse-resize");
            } else if (
                this.cursor !== "nesw-resize" &&
                ["rightTop", "leftBottom"].includes(overCorner)
            ) {
                this.chooseCursor("nesw-resize");
            }
        } else if (isOverRect) {
            if (this.cursor !== "move") {
                this.chooseCursor("move");
            }
        } else if (this.cursor !== "default") {
            this.chooseCursor("default");
        }
    }

    chooseCursor(cursor: string) {
        document.body.style.cursor = cursor;
        this.cursor = cursor;
    }

    unselect() {
        super.unselect();
        this.mousedownOnCorner = null;
        this.isMousedownOnRect = false;
        this.chooseCursor("default");
    }

    private getScreen(): ImageExportScreen | null {
        return canv.appInterface.imageExportWindow.screen ?? null;
    }

    cursor = "default";
    name = "imageExportTool";
    mousedownOnCorner: ImageExportCorner | null = null;
    isMousedownOnRect = false;
}
